import { Link } from 'react-router-dom';

import { useFooterQuery } from '@api/FooterApr/footer.queries';

import { useLangLink } from '@hooks/useLangLink';

import { getNormalizeText } from '@utils/getNormalizeText';
import { getMediaUrl } from '@utils/getMediaUrl';

import Logo from '@components/Logo/Logo';

import css from './Footer.module.scss';

const BASE_MENU = [
  [
    { to: '/mt5', label: 'MT5' },
    { to: '/account', label: 'Account Types' },
    { to: '/partners', label: 'For Partners' },
  ],
  [
    { to: '/tutorial', label: 'Tutorials' },
    { to: '/news', label: 'News' },
    { to: '/glossary', label: 'Glossary' },
    { to: '/faq', label: 'FAQ' },
  ],
  [
    { to: '/about', label: 'About RIIB' },
    { to: '/legal-pack', label: 'Legal Pack' },
    { to: '/contact', label: 'Contact Us' },
  ],
];

const footerContent = {
  description: [
    '<span>Risk warning:</span> Trading Contract for Differences (CFDs) carries a high level of risk since leverage can work both to your advantage and disadvantage. As a result, CFDs may not be suitable for all investors because it is possible to lose all of your invested capital. You should never invest money that you cannot afford to lose. Before trading in complex financial products, please ensure to understand the risks involved.',
    '<span>Disclosure:</span> “RIIB Limited (“the Company”), the Company limited by shares that is formed and registered under the Laws of the Abu Dhabi Global Market (“ADGM”) under license number 000028057, authorized and regulated by the Financial Services Regulatory Authority (“FSRA”) under reference number XXXX, having its registered offices at Unit. 610, Floor. 6, Sky Tower, Shams Abu Dhabi, Al Reem Island, United Arab Emirates. The Company is a duly licensed Category 3A Firm authorized to provide financial products and services to persons who meet the qualifying criteria of a Professional Client and/or Market Counterparty as defined in the ADGM Conduct of Business Rulebook. The proposed financial services and/or the provided marketing material, promoted products, or communicated information is only available to Professional Client and/or Market Counterparty and should not be distributed to Retail Clients or potential Retail Clients (as defined under the rules of the ADGM).”',
    '<span>Disclaimer:</span> The content on this page is for informational purposes only and is not intended as a recommendation or advice. Any references to past performance, emulated performance, or forecasts in the Company’s advertisements are not reliable indicators of future results. Customers are solely responsible for their own business decisions or investments.',
  ],
  contact: {
    email: 'support@riib.com',
    emailBottomText: 'GET IN TOUCH',
    social: [
      { href: '#', icon: '/assets/icons/soc_1.svg' },
      { href: '#', icon: '/assets/icons/soc_2.svg' },
      { href: '#', icon: '/assets/icons/soc_3.svg' },
    ],
  },
  bottom: {
    links: [{ to: '/legal-pack', label: 'LEGAL Pack' }],
    copyright: '© 2025 Riib. All rights reserved',
  },
};

const Footer = () => {
  const { withLang } = useLangLink();

  const { data, isLoading } = useFooterQuery();

  if (isLoading) return null;

  const { disclaimer, navigation, email, socials } = data;

  return (
    <footer className={css.footer}>
      <div className={css.footer__dec}>
        <img src="/assets/decor/footer_dec.png" alt="" />
      </div>

      <div className="container">
        <div className={css.footer__main}>
          <div>
            <div
              className={css.footer__text}
              dangerouslySetInnerHTML={{
                __html: getNormalizeText(disclaimer),
              }}
            />
          </div>

          <div>
            <nav className={css.footer__navmenu}>
              <ul>
                {navigation.map(({ item, id }) => (
                  <li key={id}>
                    <ul>
                      {item.map(item => (
                        <li key={item.id}>
                          <Link to={withLang(item.to)}>{item.label}</Link>
                        </li>
                      ))}
                    </ul>
                  </li>
                ))}
              </ul>
            </nav>

            <address className={css.footer__address}>
              <div className={css.mail}>
                <a href={`mailto:${email}`}>{email}</a>

                <p>GET IN TOUCH</p>
              </div>

              <ul className={css.soc}>
                {socials.map((soc, index) => (
                  <li key={index}>
                    <a
                      href={soc.link}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img src={getMediaUrl(soc.icon)} alt="" />
                    </a>
                  </li>
                ))}
              </ul>
            </address>
          </div>
        </div>

        <div className={css.footer__bottom}>
          <Logo inhrClass={css.logo} />

          {/* <ul>
            {bottom.links.map((link, index) => (
              <li key={index}>
                <Link to={link.to}>{link.label}</Link>
              </li>
            ))}
          </ul> */}

          <p>© {new Date().getFullYear()} Riib. All rights reserved</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
